module.exports = __webpack_public_path__ + "img/zj.f3ba4b79.png";